<template>
  <div class="enhancify grid-module" ref="module">
    <div class="columns">
      <div class="column partners-filter">
        <form id="usersFilter" @submit.prevent.stop="clearPageSearch">
          <section class="modern-form-group">
            <div class="modern-input-controlled">
              <ModernInput  placeholder="Search..."
                            name="searchText"
                            v-model="filters.searchText"
                            type="search"/>
              <div class="modern-input-control">
                <button class="modern-button" type="submit">
                  <i class="mdi mdi-magnify"></i>
                </button>
              </div>
            </div>

            <div class="modern-input-labeled">
              <label for="status" style="white-space: nowrap">Status</label>
              <ModernSelect
                id="status"
                name="status"
                v-model="filters.status"
                optionLabelKey="value"
                optionValueKey="value"
                :options="statusOptions"
              />
            </div>

            <div class="modern-input-labeled">
              <label for="w9" style="white-space: nowrap">W-9</label>
              <ModernSelectBox
                  id="w9"
                  name="w9"
                  style="width: 13em"
                  v-model="filters.statusW9"
                  :options="w9Options">
                <template #options-footer>
                  <hr style="margin: .5em">
                  <b-checkbox form="usersFilter"
                              :true-value="1"
                              :false-value="0"
                              v-model="filters.showDifferencesOnly"
                              name="isDifferencesOnly"
                              style="padding: 2px 1em 2px 1em">
                    Show differences only
                  </b-checkbox>
                </template>
              </ModernSelectBox>
            </div>
            <div class="modern-input-labeled">
              <label for="CPActivation" style="white-space: nowrap">CP activation</label>
              <ModernSelect
                id="CPActivation"
                name="cpActivation"
                v-model="filters.cpActivation"
                :options="cpActivationOptions"
              />
            </div>
          </section>
        </form>
      </div>
    </div>
    <section class="data-grid" >
      <template v-if="!data.length">
        <b-table
          class="modern-table"
          height="100%"
          :columns="columns"
          :loading="loading"
        >
          <template #header="{ column }">
            <div :class="[{'top-sticked': isTopSticky}, column['thclass'],
           'modern-table-header-label']">
              {{ column['label'] }}
              <template v-if="column['meta']">
                <reports-table-tooltip :content="column['meta']" />
              </template>
            </div>
          </template>

          <template #empty v-if="!loading">
            <div style="padding-top: 1em; overflow: hidden; text-align: center">
            <span class="icon">
              <i class="fal fa-frown fa-3x"></i>
            </span>
              <p>Nothing here</p>
            </div>
          </template>
        </b-table>
      </template>
      <template v-else>
        <ModernTable
          ref="table"
          class="modern-table"
          height="100%"
          :loading="loading"
          :per-page="filters.limit"
          :total="total"
          :current-page.sync="filters.page"
          :data="data"
          paginated
          hoverable
          pagination-size="is-medium"
          backend-pagination
          backend-sorting
          :defaultSort="'registrationDate'"
          :defaultSortDirection="'desc'"
          @sort="sort"
        >

          <template #header="{ column }">
            <div :class="[{'top-sticked': isTopSticky}, column['thclass'],
           'modern-table-header-label']"
                 :ref="column['field']">
              {{ column['label'] }}
              <template v-if="column['meta']">
                <reports-table-tooltip :content="column['meta']" />
              </template>
            </div>
          </template>

          <template #default="{ row }">
            <b-table-column label="Switch to"
                            headerClass="switch-to-header"
                            field="hasUser"
                            width="100"
                            sortable
                            centered
                            sticky
                            :class="{sticked: isLeftSticky}">
              <b-switch v-if="row['user'] !== null"
                        :value="row['user']['id'] === userId"
                        size="is-small"
                        type="is-success"
                        class="enh-switch"
                        @input="switchTo(row['user']['id'], $event)" />
            </b-table-column>
            <b-table-column field="firstName" label="First name" width="200" sortable sticky
              :class="{sticked: isLeftSticky}" class="first-name-column" style="background: #f2f5f6"
              headerClass="first-name-header">
              <span :class="{'status-canceled': row['status']['value'] === 'Canceled'}">
                {{ row['firstName'] }}
              </span>
            </b-table-column>
            <b-table-column field="lastName" label="Last name" width="200" sortable sticky
              :class="{sticked: isLeftSticky}" class="last-name-column"
              headerClass="last-name-header">
              <span :class="{'status-canceled': row['status']['value'] === 'Canceled'}">
                {{ row['lastName'] }}
              </span>
            </b-table-column>
            <b-table-column label="Company name"
                            field="companyName" width="300"
                            sortable
                            >
              <span :class="{'status-canceled': row['status']['value'] === 'Canceled'}">
                {{ row['companyName'] }}
              </span>
            </b-table-column>
            <b-table-column field="email" label="E-mail" width="450" sortable>
              <span :class="{'status-canceled': row['status']['value'] === 'Canceled'}"
                    style="white-space: nowrap">
                <i class="fas fa-envelope has-text-success" style="margin-right: .3em" />
                <span style="white-space: break-spaces" >{{ row['email'] | lower | trim }}</span>
              </span>
            </b-table-column>
            <b-table-column field="phone" label="Phone" width="190" sortable>
              <span :class="{'status-canceled': row['status']['value'] === 'Canceled'}">
               <i class="pb-10 fas fa-rotate-90 fa-phone has-text-success" />
               {{ row['phone'] | phone }}
              </span>
            </b-table-column>
            <b-table-column field="status" label="Status" width="220" sortable>
              <span :class="{
              'w9-success': row['status']['value'] === 'Active',
              'w9-info': row['status']['value'] === 'Pending',
              'status-canceled': row['status']['value'] === 'Canceled',
              }">
                {{ row['status'] ? row['status']['value'] : null }}
              </span>
            </b-table-column>
            <b-table-column field="plan" label="Plan" width="320" sortable>
              <span :class="{'status-canceled': row['status']['value'] === 'Canceled'}">
                {{ row['plan'] ? row['plan']['name'] : null}}
              </span>
            </b-table-column>
            <b-table-column field="lead" label="Lead" width="550" sortable>
              <span :class="{'status-canceled': row['status']['value'] === 'Canceled'}">
                <a :href="`https://app.close.com/lead/${row['leadId']}`" target="_blank">{{ row['leadId'] }}</a>
              </span>
            </b-table-column>
            <b-table-column field="registrationDate"
                            label="Registration date" width="190" sortable>
              <span :class="{'status-canceled': row['status']['value'] === 'Canceled'}">
                {{ row['registrationDate'] | dateFormat }}
              </span>
            </b-table-column>
            <b-table-column field="cpActivation" label="CP activation" width="190" sortable>
              <span :class="{'status-canceled': row['status']['value'] === 'Canceled'}">
                <template v-if="get(row, 'cpActivation.error')">
                  <span style="color: red; cursor: pointer"
                        :title="cpActivationTitle(row)">
                    Error
                  </span>
                </template>
                <template v-else>
                  <span :title="cpActivationTitle(row)">
                    {{ get(row, 'cpActivation.date') | dateFormat }}
                  </span>
                </template>
              </span>
            </b-table-column>
            <b-table-column label="W-9" width="160" sortable field="w9">
              <span :class="{'status-canceled': row['status']['value'] === 'Canceled'}">
                <span v-if="row['user']" :class="{
                  'w9-success': w9Status(row) === 'Verified',
                  'w9-danger': w9Status(row) === 'Rejected',
                  'w9-info': w9Status(row) === 'Pending'
                }">
                  <a  :class="{
                  'w9-success': w9Status(row) === 'Verified',
                  'w9-danger': w9Status(row) === 'Rejected',
                  'w9-info': w9Status(row) === 'Pending'
                }" v-if="w9Status(row)"
                      @click="openW9Form(row)">
                    {{ w9Status(row) }}
                  </a>
                  <span v-else>Not Found</span>
                  <i v-if="w9Status(row)
                       && row['w9Tax'].isDifferent && !row['w9Tax'].skipDifferences"
                     class="mdi mdi-alert-circle mdi-24px has-text-danger"></i>
                </span>
              </span>
            </b-table-column>
            <b-table-column field="id" label="ID" width="160" sortable>
              <span :class="{'status-canceled': row['status']['value'] === 'Canceled'}">
                {{ row['id'] }}
              </span>
            </b-table-column>
            <b-table-column field="leadOwner" label="Lead Owner" width="160" sortable>
              <span :class="{
              'status-canceled': row['status']['value'] === 'Canceled',
            }">
              {{ row['leadOwner'] ? row['leadOwner']['name'] : null }}
              </span>
            </b-table-column>
            <b-table-column width="150" centered>
              <div class="table-control">
                <button
                    v-if="isSendConfirmEmailAvailable(row)"
                    title="Resend activation link"
                    class="button control-button"
                    @click="sendConfirmEmail(row)"
                >
                  <span class="icon">
                    <i class="fas fa-envelope has-text-success"></i>
                  </span>
                </button>
                <button
                    v-if="authAuthenticator(PARTNERS_MODIFY_MANAGE)"
                    title="Edit partner"
                    class="button control-button"
                    @click="onEditPartnerClick(row)"
                >
                    <span class="icon">
                      <i class="fas fa-pencil-alt has-text-success"></i>
                    </span>
                </button>
              </div>
            </b-table-column>
          </template>

          <template #bottom-left>

            <div class="modern-input-labeled">
              <label class="per-page" for="paymentStatus"
                     style="font-weight: 700; white-space: nowrap">
                Per page
              </label>
              <ModernSelect
                style="margin-right: 1em"
                v-model="filters.limit"
                :options="perPageOptions"
              />
            </div>
          </template>

          <template #empty v-if="!loading">
            <div style="padding-top: 1em; overflow: hidden; text-align: center">
            <span class="icon">
              <i class="fal fa-frown fa-3x"></i>
            </span>
              <p>Nothing here</p>
            </div>
          </template>
        </ModernTable>
      </template>
    </section>
  </div>
</template>

<script>
import ModernInput from '@/components/ModernInput.vue';
import ModernSelect from '@/components/ModernSelect.vue';
import ModernSelectBox from '@/components/ModernSelectBox.vue';
import W9TaxForm from '@/components/Modal/W9TaxForm.vue';
import { DialogProgrammatic as Dialog } from 'buefy';
import { confirmAccount } from '@/api/user';
import { manageSearch as getPartners } from '@/api/partner';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { get, omit, pick } from 'lodash';
import * as MUTATIONS from '@/store/mutations';
import * as ACTIONS from '@/store/actions';
import Vue from 'vue';
import ModernTable from '@/components/ModernTable.vue';
import ReportsTableTooltip from '@/components/Widgets/ReportsTableTooltip.vue';
import UsersPartnerForm from '@/views/Manage/Users/UsersPartnerForm/UsersPartnerForm.vue';
import { PARTNERS_MODIFY_MANAGE } from '@/const/privileges';

export default {
  name: 'Partners',
  components: {
    ReportsTableTooltip,
    ModernTable,
    ModernSelect,
    ModernSelectBox,
    ModernInput,
  },

  data() {
    const help = {
      type: `The field shows the customer category: Contractor, Medical, or General.<br>
      If the customer type differs from the business type, the business type is also displayed.`,
    };

    return {
      PARTNERS_MODIFY_MANAGE,
      statusOptions: [
        { value: '', label: '' },
        { value: 'Active', label: 'Active' },
        { value: 'Canceled', label: 'Canceled' },
        { value: 'Pending', label: 'Pending' },
      ],
      w9Options: [
        { value: '', label: '' },
        { value: 'Not found', label: 'Not found' },
        { value: 'Pending', label: 'Pending' },
        { value: 'Verified', label: 'Verified' },
        { value: 'Rejected', label: 'Rejected' },
      ],
      cpActivationOptions: [
        { value: '', label: '' },
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' },
        { value: 'Error', label: 'Error' },
      ],

      filters: {
        searchText: '',
        showDifferencesOnly: 0,
        statusW9: '',
        status: '',
        cpActivation: null,
        page: 1,
        limit: 25,
        sortField: 'registrationDate',
        sortOrder: 'desc',
      },

      loading: false,
      fixedHeader: false,
      stripWidth: 0,
      scroll: 0,
      total: 0,
      perPageOptions: [{ value: 10 }, { value: 25 }, { value: 50 }, { value: 100 }],
      isLeftSticky: false,
      isTopSticky: false,

      data: [],
      help,
      columns: [
        {
          field: 'hasUser',
          label: 'Switch to',
          headerClass: 'switch-to-header',
          sticky: true,
          width: 100,
        },
        {
          field: 'firstName',
          label: 'First name',
          sortable: true,
          width: 250,
          sticky: true,
          headerClass: 'first-name-header',
        },
        {
          field: 'lastName',
          label: 'Last name',
          sortable: true,
          width: 250,
          sticky: true,
          headerClass: 'last-name-header',
        },
        {
          field: 'companyName',
          label: 'Company name',
          sortable: true,
          sticky: false,
          width: 300,
        },
        {
          field: 'email', label: 'E-mail', sortable: true, width: 450,
        },
        {
          field: 'phone', label: 'Phone', sortable: true, width: 170,
        },
        {
          field: 'Plan', label: 'Plan', sortable: true, width: 320,
        },
        {
          field: 'registrationDate', label: 'Registration date', sortable: true, width: 160,
        },
        {
          field: 'cpActivation', label: 'CP activation', sortable: true, width: 160,
        },
        {
          field: 'lead', label: 'Lead', sortable: true, width: 550,
        },
        {
          field: 'status', label: 'Status', sortable: true, width: 150,
        },
        {
          field: 'w9', label: 'W-9', sortable: true, width: 160,
        },
        {
          field: 'Id', label: 'ID', sortable: true, width: 160,
        },
        { field: '', label: '', width: 150 },
      ],
    };
  },

  async activated() {
    const planFilters = this.$route.query.searchText || null;
    if (planFilters) {
      this.filters.searchText = planFilters;
      this.$route.query.searchText = null;
      await this.search();
    }
    this.fixedHeader = false;
    await this.search();
  },
  async mounted() {
    this.statusOptions = [{ id: null, value: '' }, ...this.partnerStatuses];

    const planFilters = this.$route.query.searchText || null;
    if (planFilters) {
      this.filters.searchText = planFilters;
      this.$route.query.searchText = null;
      await this.search();
      return;
    }

    if (this.$route.query.companyName) {
      this.filters.searchText = this.$route.query.companyName;
      await this.search();
    } else {
      await this.search();
    }
  },

  watch: {
    queryParams() {
      this.filters.page = 1;
      this.search();
    },

    pageOrderParams() {
      this.search();
    },
  },

  computed: {
    ...mapState('user', {
      userId: (state) => state.id,
    }),
    ...mapState('auth2', {
      userAuthEmail: (state) => state.email,
    }),
    ...mapGetters(['isSwitched', 'authAuthenticator']),
    ...mapState({ windowWidth: (state) => state.windowWidth }),
    ...mapState('constant', ['partnerStatuses']),

    pageOrderParams() {
      return JSON.stringify(pick(this.filters, ['page', 'sortOrder', 'sortField']));
    },

    queryParams() {
      return JSON.stringify(omit(this.filters, ['searchText', 'page', 'sortOrder', 'sortField']));
    },
  },

  methods: {
    get, // shortand lodash _.get declaration
    ...mapMutations({ preloader: MUTATIONS.SET_PRELOADER }),

    cpActivationTitle(row) {
      if (get(row, 'cpActivation.date')) {
        return this.$options.filters.dateFormat(get(row, 'cpActivation.date'));
      }
      return get(row, 'cpActivation.error', '');
    },

    isSendConfirmEmailAvailable(record) {
      return record.user
          && (
            record.cpActivation === null
            || Object.keys(record.cpActivation).length === 0
            || record.cpActivation.error
          );
    },

    w9Status(row) {
      return get(row, 'w9Tax.status', '');
    },

    extractW9Options(rowData) {
      const w9Tax = rowData.w9Tax ?? {};
      return {
        fullName: w9Tax.fullName ?? '',
        companyName: w9Tax.companyName ?? '',
        status: w9Tax.status ?? 'Not Found',
        isSSN: w9Tax.isSSN,
        isEIN: w9Tax.isEIN,
        isDifferent: w9Tax.isDifferent,
        skipDifferences: w9Tax.skipDifferences,
        danger: Boolean(w9Tax.status && w9Tax.isDifferent && !w9Tax.skipDifferences),
      };
    },

    async clearPageSearch() {
      this.filters.page = 1;
      await this.search();
    },

    async search(scrollToTop = true) {
      this.loading = true;
      try {
        const { data } = await getPartners({
          ...this.filters,
          userId: this.isSwitched ? this.userId : null,
        });
        this.data = data.data;
        this.total = data.total;
        this.sortByChecked();
      } catch (error) {
        Dialog.alert({
          message: `${error.message}<br/>Error: loading`,
          type: 'is-danger',
          title: 'Error',
        });
      } finally {
        setTimeout(() => {
          if (scrollToTop) {
            if (this.$refs.table) {
              this.$refs.table.scrollTop();
            }
          }
          this.loading = false;
        }, 200);
      }
    },

    sortByChecked() {
      const checkedRows = this.data.filter((row) => row.user !== null
          && row.user.id === this.userId);
      checkedRows.forEach((row) => {
        this.data.splice(this.data.indexOf(row), 1);
        this.data.unshift(row);
      });
    },

    async switchTo(value, checked) {
      const userId = checked ? value : this.$store.state.auth2.id;
      this.$store.commit(MUTATIONS.SET_SPLASH, true);

      try {
        await this.$store.dispatch(ACTIONS.SWITCH_USER, userId);
        this.sortByChecked();
        await this.$router.replace('/');
      } catch (err) {
        Dialog.alert({
          message: `${err.message}<br/>Error: switch back`,
          type: 'is-danger',
          title: 'Error',
          onConfirm: this.switchTo(null, false),
        });
      } finally {
        this.$store.commit(MUTATIONS.SET_SPLASH, false);
      }
    },

    sendConfirmEmail(rowData) {
      this.$buefy.dialog.confirm({
        message: `An email with an activation link will be sent to <b>${rowData.email}</b>`,
        confirmText: 'RESEND',
        type: 'is-success',
        cancelText: 'CANCEL',
        title: 'Resend activation link',
        onConfirm: () => {
          this.preloader(true);
          confirmAccount(rowData.user.id)
            .then((response) => {
              this.$buefy.toast.open({
                type: 'is-success',
                message: response.data.message,
                duration: 3000,
              });
            })
            .catch((error) => {
              this.$buefy.toast.open({
                type: 'is-danger',
                message: this.lodash.get(error, 'response.data.message', 'Undefined error'),
                duration: 3000,
              });
            })
            .finally(() => { this.preloader(false); });
        },
      });
    },

    onEditPartnerClick(rowData) {
      const Component = Vue.extend(UsersPartnerForm);
      const modal = new Component({
        propsData: {
          active: false,
          id: rowData.id,
          statuses: this.partnerStatuses,
        },
      });

      modal.$store = this.$store;

      modal.$on('success-submit', () => {
        this.search();
      });
      modal.$on('close', () => {
        this.$refs.module.removeChild(modal.$el);
      });

      modal.$mount();
      this.$refs.module.appendChild(modal.$el);
    },

    openW9Form(record) {
      const entity = {
        ...record,
        fullName: `${record.firstName} ${record.lastName}`,
        w9: this.extractW9Options(record),
      };
      const Component = Vue.extend(W9TaxForm);
      const modal = new Component({
        propsData: {
          entityId: entity.id,
          entityType: 'partner',
          active: true,
          taxClassificationIsChecked: 0,
          openExistW9: 1,
          entity,
        },
      });

      modal.$store = this.$store;
      modal.$mount();
      modal.$on('submit', (response) => {
        if (response) {
          this.$refs.module.removeChild(modal.$el);
          this.search(false);
        }
      });
      modal.$on('close', () => {
        this.$refs.module.removeChild(modal.$el);
      });
      this.$refs.module.appendChild(modal.$el);
    },

    sort(field, order) {
      this.filters.sortField = field;
      this.filters.sortOrder = order;
    },
  },
};
</script>

<style scoped lang="stylus">
@require "../../../assets/style/modern/variables.styl";
.text-tip
  font-size .8em
::v-deep .modern-card__body .label
  font-weight 400

.modern-card__footer
  .button
    min-width 135px
.button.button-cancel
  text-transform uppercase
  border-color #23D160
  color #23D160
.button.button-cancel:hover
  background #17b548
  color white

.help-text
  color #969ea2

::v-deep .b-table.is-loading:after
  z-index 10

footer.modal-card-foot
  padding 12px
  justify-content end

::v-deep .enh-switch input[type=checkbox]:checked + .check.is-success
  background #68ba62

::v-deep .modal .animation-content .modal-card
  margin 0 auto

::v-deep .enh-switch:hover input[type=checkbox]:checked + .check.is-green
  background #17b548

::v-deep .fixed-header .first-name-header
  left 100px !important

::v-deep .first-name-column.is-sticky
  left 100px !important

::v-deep .first-name-header
  left 100px !important

::v-deep .last-name-column.is-sticky
  left 300px !important

::v-deep .last-name-header
  left 300px !important

::v-deep .company-name-header
  min-width 300px

::v-deep table th.first-name-header.is-sticky,
::v-deep table th.last-name-header.is-sticky,
::v-deep table th.switch-to-header.is-sticky
  z-index 9 !important

::v-deep .status-canceled
  @media (min-width: $breakpoints.md)
    opacity 0.6
@media (max-width: $breakpoints.md)
  ::v-deep .modern-table
    td::before
      padding-right 1.5em !important
      white-space nowrap
  .tooltip-icon-container
    margin-left: -1.2em
  .report-table__value_fixed
    margin-left auto
  ::v-deep .level-left
    .modern-input-labeled
      justify-content center
    .modern-select
      flex-grow unset !important
      max-width 120px

@media (max-width: $breakpoints.md)
  .modern-input-controlled
    padding-top 0
  .modern-input-labeled, .modern-input-controlled
    margin-right 0
  .sm-hide
    display none !important
  .sm-show
    display flex !important

  .btn-flex
    display: flex;
    justify-content: end
    @media screen and (max-width: $breakpoints.md)
      width 100%
      justify-content: end
      .modern-button
        max-width 160px;

.w9-success
  color green
.w9-danger
  color #8b0000
.w9-info
  color #1e90ff

::v-deep th
  height 102px
::v-deep .switch-to-header
  left 0 !important

::v-deep .fixed-header .first-name-header
  left 100px !important

::v-deep .first-name-column
  left 100px !important

::v-deep .first-name-header
  left 100px !important

::v-deep last-name-column
  left 300px !important

::v-deep .last-name-header
  left 300px !important

::v-deep .company-name-header
  min-width 300px

::v-deep table th.first-name-header.is-sticky,
::v-deep table th.last-name-header.is-sticky,
::v-deep table th.switch-to-header.is-sticky
  z-index 9 !important

td
  min-width 140px

.switch-to-header
  .modern-table-header-label
    margin-right unset

::v-deep .switch-to-header .icon
  margin-left .1em !important

td[data-label="First name"]
  overflow-wrap anywhere
  white-space normal

td[data-label="Last name"]
  overflow-wrap anywhere
  white-space normal

td[data-label="Phone number"]
  white-space nowrap !important
  overflow-wrap unset

.per-page:after
  content: ''

.data-grid
  padding-bottom 2em

.control-button
  margin 0
  background transparent
  border none
  font-size 24px
  padding 0

.floating-button
  margin-left auto
  margin-right 0

.table-control
  display flex
  justify-content end
  gap 1em
  button
    width 36px
    height 36px !important
  .icon
    font-size 24px
    i
      color #68ba62 !important
      &:hover
        color #17b548 !important
td:has(span.status-canceled)
  @media (max-width: $breakpoints.md)
    opacity 0.6
</style>
